import { parsePrice } from '@/lib/utils';
import { ProductListItem } from '@/types';

interface PriceBlock {
    variation: ProductListItem;
}

export function PriceBlock({ variation }: PriceBlock) {
    const isKeg = variation.packType === 'keg';
    const isKor = variation.packType === 'kor';

    const numericPrice = parsePrice(variation.price);
    const numericVolume = parseFloat(variation.volume);

    const pricePerLiter =
        isKeg && numericVolume > 0
            ? Math.round(numericPrice / numericVolume)
            : null;

    return (
        <div className="flex flex-col">
            <div className="flex items-baseline gap-1 font-['Oswald'] text-xl font-bold text-zinc-100">
                {isKeg ? pricePerLiter + ' ₽' : variation.price}
                {isKeg ? (
                    <span className="text-sm">/ за л</span>
                ) : (
                    <span className="text-sm">/ за шт</span>
                )}
            </div>
            <div>
                <span className="text-left text-sm text-brand-gold">
                    {isKor
                        ? numericPrice * (variation.packQuantity ?? 1) +
                          ` ₽ / за кор ${variation.packQuantity}шт`
                        : null}
                    {isKeg
                        ? variation.price + ` / за кегу ${variation.volume}л `
                        : null}
                </span>
            </div>
        </div>
    );
}
